import React, { Component } from 'react'
import { CFButton } from 'cf-web-app/components'
import { ThemeContext } from 'cf-web-app'

export default class TextButton extends Component {
  render() {
    const { label, onClick, disabled } = this.props
    return (
      <CFButton onClick={onClick} disabled={disabled}>
        <ThemeContext.Consumer>
          {({ Components }) => (
            <Components.TextButtonView label={label} disabled={disabled} />
          )}
        </ThemeContext.Consumer>
      </CFButton>
    )
  }
}
